import { styled, css } from "styled-components";
import Colors from "./Colors";
import rem from "../utils/rem";
export const textInputThemes = {
    default: {
        borderColor: Colors.GRAY,
        backgroundColor: Colors.WHITE,
        placeholderNotShownBorderColor: Colors.GRAY_DARKEST,
        hoverBorderColor: Colors.GRAY_DARK,
        focusBorderColor: Colors.BLACK_2024,
        placeholderNotShownIconColor: "GRAY_DARKEST",
        iconColor: "GRAY_DARK",
    },
    error: {
        borderColor: Colors.ALERT_ERROR,
        backgroundColor: Colors.ALERT_ERROR_LIGHT,
        placeholderNotShownBorderColor: Colors.ALERT_ERROR,
        hoverBorderColor: Colors.ALERT_ERROR,
        focusBorderColor: Colors.ALERT_ERROR,
        placeholderNotShownIconColor: "GRAY_DARKEST",
        iconColor: "GRAY_DARK",
    },
    success: {
        borderColor: Colors.BLACK_2024,
        backgroundColor: "none",
        placeholderNotShownBorderColor: Colors.BLACK_2024,
        hoverBorderColor: Colors.BLACK_2024,
        focusBorderColor: Colors.BLACK_2024,
        placeholderNotShownIconColor: "GRAY_DARKEST",
        iconColor: "GRAY_DARK",
    },
};
export const LabelWrapper = styled.div `
  position: relative;
  width: 100%;
`;
export const genericInputFieldStyles = css `
  appearance: none;
  display: block;
  font-size: ${rem(18)};
  border: 1px solid ${({ theme }) => theme.vars.borderColor};
  box-sizing: border-box;
  border-radius: 5px;
  background: ${({ theme }) => theme.vars.backgroundColor};
  padding: ${rem(16)} ${rem(15)};
  color: ${Colors.GRAY_DARKEST};
  outline: none;
  width: 100%;

  ${({ theme }) => theme.state.hasLeadingIcon &&
    css `
      padding-left: ${rem(14 + 30 + 14)};
    `}
  ${({ theme }) => theme.state.hasTrailingIcon &&
    css `
      padding-right: ${rem(14 + 30 + 14)};
    `}


  &:not(:disabled)::placeholder {
    color: ${Colors.GRAY_DARK};
  }
  ${({ theme }) => theme.state.hasValue &&
    css `
      border-color: ${theme.vars.placeholderNotShownBorderColor};
    `}

  &:hover:not(:disabled) {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    border-color: ${({ theme }) => theme.vars.hoverBorderColor};
  }
  &:focus:not(:disabled) {
    border-color: ${({ theme }) => theme.vars.focusBorderColor};
  }

  &:disabled {
    background: ${Colors.GRAY_LIGHT};
    color: ${Colors.GRAY_DARK};
    border: 1px solid transparent;
  }
`;
export const InputWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
export const InputIconWrapper = styled.div `
  position: relative;
  flex: 1;
`;
export const FeedbackWrapper = styled.div `
  width: 100%;
  margin-top: 10px;
  > div {
    color: ${Colors.PROFILE_RED_2024};
  }
`;
export const ErrorMessage = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${Colors.ALERT_ERROR_LIGHT};
  color: ${Colors.ALERT_ERROR};
  line-height: 1.5;
  margin-top: 0.5rem;
  padding: ${rem(16)} ${rem(15)};
`;
//# sourceMappingURL=sharedInputStyles.js.map